import Upsertable from '@/models/Upsertable'
import { useSurveyStore } from '@/stores/surveyStore'
import SurveyQuestion from './SurveyQuestion'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Survey extends Upsertable {
  static store() {
    return useSurveyStore()
  }

  store() {
    return Survey.store()
  }

  static all() {
    return Survey.store().all()
  }

  static find(uuid) {
    const obj = Survey.store().find(uuid)
    let survey = new Survey()
    return Object.assign(survey, obj)
  }

  static findByName(name) {
    const obj = Survey.store().all().find(survey => survey.name.toLowerCase() == name.toLowerCase())
    let survey = new Survey()
    return Object.assign(survey, obj)
  }

  survey_questions() {
    let questions = SurveyQuestion.find_all_by_survey_uuid(this.uuid)
    let surveyQuestionObjects = []
    questions.forEach(function (item) {
      surveyQuestionObjects.push(Object.assign(new SurveyQuestion(), item))
    })
    return surveyQuestionObjects
  }
}

useModelName(Survey, "Survey")
ModelRegistry.register(Survey, "Survey")